const setupFeaturedInMarquee = (marquee) => {
  const track = marquee.querySelector('[data-featured-in-track]');
  if (!track) return;

  const originals = Array.from(track.children).filter((child) => !child.dataset.clone);
  if (!originals.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const build = () => {
    track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const setWidth =
      originals.reduce((total, item) => total + item.getBoundingClientRect().width, 0) +
      gap * (originals.length - 1);
    if (!setWidth) return;

    /* One sequence is the logos plus the gap that follows them, so shifting the
       track by exactly that lands the next copy where the first one started. */
    const distance = setWidth + gap;
    const copies = Math.max(2, Math.ceil(marquee.getBoundingClientRect().width / distance) + 1);

    for (let copy = 1; copy < copies; copy += 1) {
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.dataset.clone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
      });
    }

    const speed = parseFloat(marquee.dataset.speed) || 60;
    track.style.setProperty('--featured-in-distance', `${distance}px`);
    track.style.setProperty('--featured-in-duration', `${distance / speed}s`);
    marquee.classList.add('is-ready');
  };

  build();

  /* Logos are lazy-loaded, so the first measurement can happen before they have
     dimensions. */
  let pending;
  const rebuild = () => {
    clearTimeout(pending);
    pending = setTimeout(build, 150);
  };

  track.querySelectorAll('img').forEach((image) => {
    if (!image.complete) image.addEventListener('load', rebuild, { once: true });
  });

  if ('ResizeObserver' in window) {
    new ResizeObserver(rebuild).observe(marquee);
  } else {
    window.addEventListener('resize', rebuild);
  }
};

const initFeaturedInBanners = (root) => {
  (root || document).querySelectorAll('[data-featured-in-marquee]').forEach(setupFeaturedInMarquee);
};

document.addEventListener('DOMContentLoaded', () => initFeaturedInBanners());

document.addEventListener('shopify:section:load', (event) => initFeaturedInBanners(event.target));
